import {
  searchFieldSx,
  textFieldSx
} from '../../../../../Common/components/Styles/InputStyles';

export const rootSx = {
  p: 0,
  flex: 1,
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden'
};

export const filtersRowSx = {
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  gap: 1.5,
  mb: 2,
  px: 1.5
};

export const searchSx = {
  ...searchFieldSx,
  width: '35%'
};

export const selectControlSx = {
  ...textFieldSx,
  width: '21%'
};

export const statusRowSx = {
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  gap: 1.5,
  mb: 2,
  px: 1.5
};

export const getStatusChipSx = (
  statusFilter,
  key,
  config
) => {
  const isActive = statusFilter === key;

  return {
    height: 30,
    borderRadius: '4px',
    bgcolor: isActive
      ? config.activeBg
      : config.bg,
    color: '#212121',
    fontWeight: 500,
    cursor: 'pointer',
    gap: 0.5,
    textTransform: 'uppercase',

    border: `1px solid ${
      isActive
        ? config.activeBorder
        : config.border
    }`,

    '& .MuiChip-icon': {
      color: '#333333',
      fontSize: 18
    },

    '& .MuiChip-label': {
      px: 1,
      fontSize: 12,
      fontWeight: 500
    },

    '&:hover': {
      bgcolor: isActive
        ? config.activeBg
        : config.bg
    }
  };
};

export const tableWrapperSx = {
  flex: 1,
  minHeight: 0,
  overflow: 'hidden',
  borderTop: '1px solid #E0E0E0'
};

export const tableContainerSx = {
  height: '100%',
  minHeight: 0,
  overflowY: 'auto',
  overflowX: 'hidden',
  scrollbarWidth: 'thin',
  scrollbarColor: '#BDBDBD transparent',

  '&::-webkit-scrollbar': {
    width: 5
  },

  '&::-webkit-scrollbar-track': {
    backgroundColor: 'transparent'
  },

  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#BDBDBD',
    borderRadius: '10px'
  },

  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: '#9E9E9E'
  }
};

export const tableSx = {
  width: '100%',
  tableLayout: 'fixed',

  '& .MuiTableCell-root': {
    padding: '0 14px'
  },

  '& .MuiTableRow-root': {
    height: 38
  }
};

export const headCellSx = {
  fontSize: 12,
  fontWeight: 500,
  color: '#424242',
  backgroundColor: '#FAFAFA',
  borderBottom: '1px solid #E0E0E0',
  textTransform: 'uppercase',
  height: 40,
  padding: '0 18px'
};

export const bodyCellSx = {
  fontSize: 12,
  fontWeight: 400,
  color: '#424242',
  borderBottom: '1px solid #EEEEEE',
  height: 40,
  padding: '0 18px'
};

export const nameCellSx = {
  ...bodyCellSx,
  fontWeight: 500,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis'
};

export const dateCellSx = {
  ...bodyCellSx,
  whiteSpace: 'nowrap'
};

export const getSignatureCellSx = status => ({
  ...bodyCellSx,
  textAlign: 'left',
  whiteSpace: 'nowrap',

  color:
    status === 'signed'
      ? '#2EAE43'
      : status === 'unsigned'
        ? '#FF4D4F'
        : '#757575'
});

export const actionCellSx = {
  ...bodyCellSx,
  textAlign: 'center'
};

export const actionWrapperSx = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};

export const blockIconSx = {
  fontSize: 18,
  color: '#757575'
};

export const tableRowSx = {
  height: 38,

  '&:hover': {
    backgroundColor: '#FCF8F2'
  }
};

export const emptyCellSx = {
  py: 3,
  textAlign: 'center'
};